<template>
  <footer id="footer" class="container-fluid">
    <div class="footer-content">
      <div class="logo">
        <img src="@/assets/img/logo_black.png" alt="公司標誌">
      </div>
      <h2 class="title"> {{ companyInfoItem.comname || $t('header.companyName') }} </h2>
      <div class="contact-info">
        <p class="address">
          <span><i class="fas fa-map-marker-alt"></i> {{ $t('footer.address') }}{{ companyInfoItem.address || '香港新界屯門建發里4號' }}</span>
        </p>
        <div class="contact-row">
          <span><i class="fas fa-phone"></i> {{ $t('footer.phone') }}{{ companyInfoItem.telephone || '+ 852 3956 3953' }}</span>
          <span><i class="fas fa-mobile-alt"></i> {{ $t('footer.mobile') }}{{ companyInfoItem.phone || '+ 852 6709 6716' }} </span>
        </div>
        <p class="wechat">
          <span><i class="fab fa-weixin"></i>{{ $t('footer.email') }}{{ companyInfoItem.mail || '--' }}</span>

          <span><i class="fab fa-weixin"></i> {{ $t('footer.wechat') }}{{ companyInfoItem.wechat || '--' }}</span>
        </p>
      </div>

      <nav class="footer-nav">
        <div class="nav-section">
          <h4>{{ $t('footer.links.title') }}</h4>
          <ul>
            <li>
              <a href="https://www.hkphea.org/zh/member-list/new-ocean-machine-co-ltd/"
                 target="_blank" rel="noopener">
                {{ $t('footer.links.hkphea') }}
              </a>
            </li>
            <li>
              <a href="https://www.builderhk.com/app/co/%E6%96%B0%E9%A2%86%E6%B5%B7%E6%9C%BA%E6%A2%B0%E8%A1%8C%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/?l=cn"
                 target="_blank" rel="noopener">
                {{ $t('footer.links.builder') }}
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/newoceanmachines/about/?_rdr"
                 target="_blank" rel="noopener">
                {{ $t('footer.links.facebook') }}
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <p class="copy">{{ $t('footer.copyright', { year: new Date().getFullYear(), company: $t('header.companyName') + ' ' + (companyInfoItem.comname_en || 'Limited') }) }}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      companyInfoItem: {},

    };
  },
  mounted() {

    // 首先尝试从 localStorage 获取数据
    const cachedData = localStorage.getItem('companyInfoItem');
    if (cachedData) {
      this.companyInfoItem = JSON.parse(cachedData);
      console.log("从缓存获取公司信息数据 = " + JSON.stringify(this.companyInfoItem));

    }

  },
};
</script>

<style scoped>
#footer {
  width: 100%;
  min-height: 180px; /* Reduced from 240px */
  color: #e0e0e0;
  background: #1b1b1b;
  padding: 30px 0; /* Reduced from 40px */
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  position: relative;
  overflow: hidden;
}

#footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: var(--primary-color); /* Accent color strip at top */
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
  position: relative;
  z-index: 2;
}

.logo {
  width: 70px; /* Reduced from 80px */
  height: auto;
  margin: 0 auto 10px; /* Reduced margin */
}

.logo img {
  width: 100%;
  height: auto;
  opacity: 0.9;
}

.title {
  font-size: 22px; /* Reduced from 24px */
  font-weight: 600;
  margin-bottom: 15px; /* Reduced from 25px */
  color: #fff;
  letter-spacing: 1px;
  display: inline-block;
}

.contact-info {
  margin: 15px 0; /* Reduced from 20px */
  line-height: 1.6; /* Slightly reduced from 1.8 */
  color: #cccccc;
}

.address, .contact-row, .wechat {
  font-size: 14px; /* Reduced from 15px */
  margin-bottom: 8px; /* Reduced from 10px */
}

.contact-row {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.wechat {
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

i {
  margin-right: 8px;
  color: var(--primary-color); /* Icon accent color */
}

.copy {
  color: #64748b;
  font-size: 12px; /* Reduced from 13px */
  margin-top: 25px; /* Reduced from 40px */
  padding-top: 15px; /* Reduced from 20px */
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

/* Footer Links */
.footer-nav {
  margin: 20px 0; /* Reduced from 30px */
}

.nav-section h4 {
  color: #fff;
  font-size: 15px; /* Reduced from 16px */
  margin-bottom: 10px; /* Reduced from 15px */
  font-weight: 600;
}

.nav-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  gap: 25px;
  flex-wrap: wrap;
}

.nav-section ul li a {
  color: #bbb;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.nav-section ul li a:hover {
  color: #f0ad4e;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .contact-row, .wechat, .nav-section ul {
    flex-direction: column;
    gap: 10px;
  }
  
  .title {
    font-size: 20px;
  }
}
</style>
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue